import { useState } from 'react';
import { fetchWithAuth } from '../../utils/apiHelper';

const useGiftCard = () => {
  const [giftCard, setGiftCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const redeemGiftCard = async (code) => {
    if (!code) return;
    setLoading(true);
    try {
      const data = await fetchWithAuth(`/giftcards/data/${code}`);
      setGiftCard(data.giftCard);
      return data.giftCard;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const resetGiftCard = () => {
    setGiftCard(null);
    setError(null);
    setLoading(false);
  };

  return { giftCard, loading, error, redeemGiftCard, resetGiftCard };
};

export default useGiftCard;
